
import zhizhen from '@/assets/lalisai/zhuanpan-zhizhen.png'
import zhizhenGray from '@/assets/lalisai/zhuanpan-zhizhen-gray.png'
import openbg from '@/assets/lalisai/popup-bg.png'



import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


import { award, isAward, getUserItem } from '@/api/lottery'
import {
addCreditParty,
relation,
getview,
cutCreditPartyNum,
cutCreditParty
} from '@/api/jfhl.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton,
Group,
XInput
},
data () {
return {
checkstyle: false,
zhizhen: zhizhen,
times: '', // 答题次数
lotid: '',
showOpen: false,
openbg: openbg,
prize: '',
start_rotating_degree: 0, // 初始旋转角度
rotate_angle: 0, // 将要旋转的角度
rotate_transition: 'transform 6s ease-in-out', // 初始化选中的过度属性控制
rotate_transition_pointer: 'transform 10s ease-in-out', // 初始化指针过度属性控制
click_flag: true, // 是否可以旋转抽奖
partyid: this.$route.params.partyid,
partyuserid: '',
prizelist: [], // 奖品列表
angle: '', // 转动角度
tablist: [
{
title: '活动规则'
},
{
title: '我的奖品'
}
],
selected: 0,
startTime: '',
endTime: '',
integral: '',

isclick: false,
zjlist: [],
animate: false,
isAward: 1, // 是否中奖
showAddress: false,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: '',
CITYID: '',
COUNTYID: '',
PROVINCEID: ''
},
addressValue: [],
addressid: '',
isAddressButton: false,
defautAddress: true
}
},
created () {
console.log(this.$route.params.obj)
if (this.$route.params.obj != null) {





this.getview() 

} else {
this.$router.push({ name: 'lalisaiIndex' })

}


},
mounted () {

},
computed: {
accountid () {
return this.$store.state.user.accountid
},



top () {
return -this.activeIndex * 30 + 'px'
}
},
watch: {
addressValue: {
handler: function (val) {
this.personObj.PROVINCEID = val[0]
this.personObj.CITYID = val[1]
this.personObj.COUNTYID = val[2]
},
deep: true
}
},
methods: {
























































































































isawardNow () {
isAward({
lotid: this.lotid,
openid: this.accountid
}).then(data => {
if (data.obj.iszhongjiang === 1) {
this.zhizhen = zhizhenGray
this.isAward = 2
this.isclick = true
this.$vux.toast.text('您已经抽过奖')
} else {
this.isclick = false
this.zhizhen = zhizhen
}
})
},









addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => { })
},

getActiveNum () {
cutCreditPartyNum({
accoutid: this.accountid
}).then(res => {
if (5 - parseInt(res.obj.num) <= 0) {
this.isclick = true
this.zhizhen = zhizhenGray
this.$vux.alert.show({
content: '您的抽奖次数已经用完'
})
}
})
},

getview () {
getview({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
this.paperInfoid = res.obj.paperid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.isCurrentTime(this.startTime, this.endTime)
this.getWinning()
})
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.$vux.alert.show({
content: '抽奖活动还未开始'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
if (currentTime >= endTime) {
this.$vux.alert.show({
content: '抽奖活动已结束'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
this.isclick = false

this.isawardNow()
},



















go () {
if (!this.isclick) {

if (this.isAward !== 2) {
this.isaward()
this.isclick = true
}
}
},
ontab (index) {
this.selected = index
},

isaward () {
award({
lotid: this.lotid,
openid: this.accountid,
lotteryNum: 1
}).then(data => {
if (data.success) {
this.isAward = data.obj.isaward
this.angle = data.obj.angle
this.prize = data.obj.item
if (data.obj.item.indexOf('积分') != -1) {
this.addJiFen(data.obj.item.replace(/[^0-9]/gi, ''))
} else {

relation({
partyuserid: this.partyuserid,
lotid: this.lotid,
userid: this.accountid
}).then(data => { })
}
this.rotating(parseInt(this.angle))
if (data.obj.isaward === 2) {
this.zhizhen = zhizhenGray
}
}
})
},

rotating (degree) {

var type = 0 
var during_time = 5 
var rand_circle = 5 
if (type === 0) {

var rotate_angle =
this.start_rotating_degree +
(360 - (this.start_rotating_degree % 360)) +
rand_circle * 360 +
degree 
this.start_rotating_degree = rotate_angle
this.rotate_angle = 'rotate(' + rotate_angle + 'deg)'

setTimeout(() => {
this.winning()
}, during_time * 1000)
}
},

getWinning () {
getUserItem({
openid: this.accountid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},

winning () {
setTimeout(() => {
this.showOpen = true
}, 2000)
},

close () {
this.showOpen = false
this.isclick = true
this.zhizhen = zhizhenGray
this.getWinning()
this.getActiveNum()
}



}
}
